import React from "react"
import {DatePicker} from "antd"

const DateInput = () => <DatePicker />
export default DateInput
